import React, { Component } from 'react';
import { Link } from 'react-router-dom';
//import './App.css';
import firebase from '../components/Firestore'

import CategoriaNombre from '../components/Admin/CategoriaNombre'
import CategoriaSelector from '../components/Admin/CategoriaSelector'
import Precio from '../components/Admin/Precio'
import Imagen from '../components/Admin/Imagen'
import NavBar from '../components/Admin/NavBar'

import config from 'react-global-configuration';

class AdminApp extends Component {

  categoriaID = React.createRef();

  constructor(props) {
    super(props);
    this.ref = firebase.firestore().collection('producto').orderBy("categoriaID");

    this.unsubscribe = null;

    this.state = {
      productos: [],
      isSignedIn: undefined
    };
  }

  onCollectionUpdate = (querySnapshot) => {
    const productos = [];
    querySnapshot.forEach((doc) => {
      const { nombre, descripcion, categoriaID, imagen, orden, precio, seFracciona, enStock } = doc.data();
      productos.push({
        key: doc.id,
        doc, // DocumentSnapshot
        nombre,
        descripcion,
        categoriaID,
        imagen,
        orden,
        precio,
        seFracciona,
        enStock
      });
    });
    this.setState({
      productos
   });
  }



  async componentDidMount() {
    this.unsubscribe = await this.ref.onSnapshot(this.onCollectionUpdate);

    // Auth
    const currentComponent = this
    this.unregisterAuthObserver = firebase.auth().onAuthStateChanged((user) => {
      this.setState({isSignedIn: !!user});
      if(user){
        let esAdministrador = config.get('admin').indexOf(firebase.auth().currentUser.email);
        if (esAdministrador < 0) currentComponent.props.history.push("/admin/login")
      }else{
        currentComponent.props.history.push("/admin/login")
      }
    });
    // fin Auth

  }

  componentWillUnmount() {
    this.unregisterAuthObserver(); // Auth
  }

  onChange = (e) => {
    //console.log("ref", e.target.value, e.target.name, this.categoriaID.current.value)

    let refFiltroCategoria = firebase.firestore().collection('producto').where("categoriaID", "==", this.categoriaID.current.value);
    this.unsubscribe = refFiltroCategoria.onSnapshot(this.onCollectionUpdate);

  }


  render() {
    return (
      <div className="container">
        <NavBar history={this.props.history} />
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              LISTA DE PRODUCTOS
            </h3>
          </div>
          <div className="panel-body">
            <div><small>Para editar/eliminar un producto tocar el nombre. Si el producto no esta en stock momentaneamente se pude editar esa opcion.</small></div>
            <table className="table table-stripe">
              <thead>
                <tr>
                  <th>
                    <div className="row">
                      <div className="col-6">Productos</div>
                      <div className="col-6">
                        <div className="row">
                          <div className="col-6 text-right"><CategoriaSelector className="d-inline" categoriaID={this.categoriaID}  /></div>
                          <div className="col-6"><button type="button" onClick={this.onChange} className="btn btn-primary d-inline">Filtrar</button></div>
                        </div>
                      </div>
                    </div>
                  </th>

                </tr>
              </thead>
              <tbody>
                {this.state.productos.map((producto, index, arr) =>

                  <tr key={producto.key} data-categoria={producto.categoriaID}>
                    <td>

                      {(producto.imagen) &&
                           <Imagen imagen={producto.imagen} nombre={producto.nombre} />
                      }

                      <span className="badge badge-secondary float-right"><CategoriaNombre categoriaID={producto.categoriaID} /></span>
                      <Link className="mr-2" to={`/admin/show/${producto.key}`}><strong>{producto.nombre}</strong></Link>
                      <small className="mr-2">{producto.descripcion}</small>
                      {(producto.orden > 0 && typeof(producto.orden) !== "undefined") &&
                        <span className="mr-2 text-success"><small>Orden aparicion: {producto.orden}</small></span>
                       }
                      <span className="mr-2"><small>{producto.seFracciona ? "Se fracciona" : "No se fracciona"}</small></span>

                      {!producto.enStock &&
                        <span className="badge badge-danger mr-2"><small>SIN STOCK</small></span>
                      }


                      <span className="text-success h6 mr-2"><Precio precioAConvertir={producto.precio}/></span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminApp;
